import {
    ApolloLink,
    InMemoryCache,
    IntrospectionFragmentMatcher,
    IntrospectionResultData,
    NormalizedCacheObject
} from 'apollo-boost';
import { setContext } from 'apollo-link-context';
import { createHttpLink } from 'apollo-link-http';

import { DNAApolloClient } from '../api/DNAApolloClient/DNAApolloClient';
import { gridSchema } from '../components/App/gridFragmentTypes';
import { logSchema } from '../components/App/logFragmentTypes';
import { getFetchWrapper } from '../service/Captcha/Captcha';

const dnaGraphqlEndpoint = '/web-api/grid/api';

const getTokenLink = (getCSRFToken: () => string): ApolloLink => {
    return setContext((_, { headers }) => {
        const token = getCSRFToken();
        // return the headers to the context so httpLink can read them
        return {
            headers: {
                ...headers,
                'X-CSRF-TOKEN': token
            }
        };
    });
};

export const getDNAApolloClient = (
    login: string,
    getCSRFToken: () => string
): DNAApolloClient<NormalizedCacheObject> => {
    const dnaCache = new InMemoryCache({
        fragmentMatcher: new IntrospectionFragmentMatcher({
            introspectionQueryResultData: gridSchema as IntrospectionResultData
        })
    });
    const tokenLink = getTokenLink(getCSRFToken);

    return new DNAApolloClient({
        cache: dnaCache,
        link: tokenLink.concat(
            createHttpLink({
                fetch: getFetchWrapper(login),
                uri: `${dnaGraphqlEndpoint}`,
                credentials: 'same-origin',
                headers: {
                    Accept: 'application/json',
                    'X-Detected-Locale': process.env.BEM_LANG || 'ru'
                }
            })
        )
    });
};

const logGraphqlEndpoint = '/web-api/user-action-log/api';

export const getLogApolloClient = (
    getCSRFToken: () => string
): DNAApolloClient<NormalizedCacheObject> => {
    const logCache = new InMemoryCache({
        fragmentMatcher: new IntrospectionFragmentMatcher({
            introspectionQueryResultData: logSchema as IntrospectionResultData
        })
    });
    const tokenLink = getTokenLink(getCSRFToken);
    const logHttpLink = tokenLink.concat(
        createHttpLink({
            fetch: getFetchWrapper(),
            uri: logGraphqlEndpoint,
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                'X-Detected-Locale': process.env.BEM_LANG || 'ru'
            }
        })
    );

    return new DNAApolloClient({
        cache: logCache,
        link: logHttpLink
    });
};

const incognitoGraphqlEndpoint = '/web-api/public/grid/api';

export const getIncognitoApolloClient = (
    getCSRFToken: () => string
): DNAApolloClient<NormalizedCacheObject> => {
    const incognitoCache = new InMemoryCache({
        fragmentMatcher: new IntrospectionFragmentMatcher({
            introspectionQueryResultData: gridSchema as IntrospectionResultData
        })
    });
    const tokenLink = getTokenLink(getCSRFToken);
    const incognitoHttpLink = tokenLink.concat(
        createHttpLink({
            fetch: getFetchWrapper(),
            uri: incognitoGraphqlEndpoint,
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                'X-Detected-Locale': process.env.BEM_LANG || 'ru'
            }
        })
    );

    return new DNAApolloClient({
        cache: incognitoCache,
        link: incognitoHttpLink
    });
};
